<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  props: {
    fileName: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    downloadable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<template>
  <div class="file-display">
    <span class="icon">
      <Icon icon="tdesign:file-1-filled" />
    </span>
    <span
      class="text"
      :class="{ downloadable }"
      @click="downloadable && $emit('download-file')"
      :title="fileName"
    >
      {{ fileName }}
    </span>
    <span v-if="closable" class="icon close" @click="$emit('remove-file')">
      <Icon icon="mdi:close" />
    </span>
    <span
      v-if="downloadable"
      class="icon close"
      @click="$emit('download-file')"
    >
      <Icon icon="mdi:download" />
    </span>
  </div>
</template>

<style scoped lang="scss">
.file-display {
  display: flex;
  align-items: center;
  gap: 5px;
  color: $blue-400;
  text-align: left;
  .text {
    max-width: 80vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .downloadable {
    cursor: pointer;
    text-decoration: underline;
  }
  .icon {
    font-size: 1.5rem;
    transform: translateY(3px);
  }
  .close {
    cursor: pointer;
  }
}
</style>
